import React from 'react';
import {convertToRaw} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../../../resources/css/emails.css';

import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

const ptTranslations = {
    // Generic
    'generic.add': 'Ok',
    'generic.cancel': 'Cancelar',
    // BlockType
    'components.controls.blocktype.h1': 'Título 1',
    'components.controls.blocktype.h2': 'Título 2',
    'components.controls.blocktype.h3': 'Título 3',
    'components.controls.blocktype.h4': 'Título 4',
    'components.controls.blocktype.h5': 'Título 5',
    'components.controls.blocktype.h6': 'Título 6',
    'components.controls.blocktype.blockquote': 'Citação',
    'components.controls.blocktype.blocktype': 'Estilo',
    'components.controls.blocktype.normal': 'Normal',
    // Color Picker
    'components.controls.colorpicker.text': 'Texto',
    'components.controls.colorpicker.background': 'Fundo',
    // Embedded
    'components.controls.embedded.embeddedlink': 'Link embarcado',
    'components.controls.embedded.enterlink': 'Coloque o link',
    // FontFamily
    'components.controls.fontfamily.fontfamily': 'Fonte',
    // Image
    'components.controls.image.fileUpload': 'Carregar arquivo',
    'components.controls.image.byURL': 'URL',
    'components.controls.image.dropFileText': 'Arraste uma imagem aqui ou clique para carregar',
    // Link
    'components.controls.link.linkTitle': 'Título do link',
    'components.controls.link.linkTarget': 'Alvo do link',
    'components.controls.link.linkTargetOption': 'Abrir link em outra janela',
};

class EmailEditor extends React.Component {

    render() {
        return (
            <Editor
                editorState={this.props.editorState}
                onEditorStateChange={this.props.onStateChange}
                localization={{ locale: 'pt', translations: ptTranslations }}
                toolbarClassName="home-toolbar"
                wrapperClassName="home-wrapper"
                editorClassName="home-editor"
                toolbar={{
                    fontFamily: {
                        options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Roboto', 'Times New Roman', 'Verdana'],
                    }
                }}
                placeholder="Crie o e-mail..."
                hashtag={{}} />
        );
    }
}

class Emails extends React.Component {

    render() {
        const app = this.props.app;
        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.EMAILS)
            return null;

        const editorContent = this.props.emailEditor.editorContent;
        const html = editorContent ? draftToHtml(convertToRaw(editorContent.getCurrentContent())) : '';
        return (
            <div className="wraper container-fluid">
                <div className="row">
                    <div className="col-lg-7">
                        <EmailEditor editorState={editorContent} onStateChange={this.props.events.onUpdateEmailEditor} />
                    </div>
                    <div className="col-lg-5">
                        <div className="row">
                            <span>Visualização temporária. Somente para validação</span>
                        </div>
                        <div className="row">
                            <textarea
                                className="form-control"
                                rows="10"
                                readOnly={true}
                                value={html}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Emails;



// WEBPACK FOOTER //
// src/views/pages/Emails.jsx